import { PublicFooter, PublicNav } from '@vextura/shell';
import type { ReactNode } from 'react';
import { PUBLIC_FOOTER, PUBLIC_NAV } from './content.js';
import { BeforeAfter } from './sections/BeforeAfter.js';
import { Demo } from './sections/Demo.js';
import { FinalCta } from './sections/FinalCta.js';
import { Founders } from './sections/Founders.js';
import { Hero } from './sections/Hero.js';
import { NotForYou } from './sections/NotForYou.js';
import { Pain } from './sections/Pain.js';
import { Pricing } from './sections/Pricing.js';
import { Proof } from './sections/Proof.js';

/**
 * Top-level composition of the marketing landing. Renders when the user is
 * signed-out. Signed-in visitors get the console shell instead — see
 * apps/console/src/App.tsx for the router flip.
 *
 * Order below is deliberate: hero (promise) → pain (problem) → before/after
 * (transformation) → proof (evidence) → demo (show) → pricing (commit) →
 * founders (trust) → not-for-you (honesty) → final-cta (last shot).
 */
export function MarketingLanding(): ReactNode {
  return (
    <div style={{ background: '#ffffff', color: '#0f172a' }}>
      <PublicNav {...PUBLIC_NAV} />
      <Hero />
      <Pain />
      <BeforeAfter />
      <Proof />
      <Demo />
      <Pricing />
      <Founders />
      <NotForYou />
      <FinalCta />
      <PublicFooter {...PUBLIC_FOOTER} />
    </div>
  );
}
